import {
  GridRowModes,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";

import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

import SyncIcon from "@mui/icons-material/Sync";

const EditToolbar = (props) => {
  const { setRowModesModel, exportFileName } = props;

  let navigate = useNavigate();

  function handleRefresh() {
    navigate(0);
  }

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport
        csvOptions={{
          fileName: `${exportFileName}`,
          delimiter: ";",
          utf8WithBom: true,
        }}
      />

      <GridToolbarQuickFilter />
      <Button color="primary" startIcon={<SyncIcon />} onClick={handleRefresh}>
        Refresh
      </Button>
    </GridToolbarContainer>
  );
};
export default EditToolbar;
